<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="size"
    :height="size"
    :style="iconSizeStyle(size)"
    viewBox="0 0 12 12"
    fill="none"
    aria-hidden="true"
    class="g-icon-close"
  >
    <path
      d="M10.2929 0.292893C10.6834 -0.0976311 11.3164 -0.0976309 11.707 0.292893C12.0975 0.683417 12.0975 1.31643 11.707 1.70696L7.41399 5.99992L11.707 10.2929C12.0975 10.6834 12.0975 11.3164 11.707 11.707C11.3164 12.0975 10.6834 12.0975 10.2929 11.707L5.99992 7.41399L1.70696 11.707C1.31643 12.0975 0.683417 12.0975 0.292893 11.707C-0.0976309 11.3164 -0.0976311 10.6834 0.292893 10.2929L4.58586 5.99992L0.292893 1.70696C-0.0976311 1.31643 -0.0976311 0.683418 0.292893 0.292893C0.683418 -0.0976311 1.31643 -0.0976311 1.70696 0.292893L5.99992 4.58586L10.2929 0.292893Z"
      fill="currentColor"
    />
  </svg>
</template>

<script setup lang="ts">
import { iconSizeStyle } from '~/utils/iconSize'

withDefaults(defineProps<{ size?: number | string }>(), {
  size: 12
})
</script>

<style scoped>
.g-icon-close {
  display: block;
  flex-shrink: 0;
  color: inherit;
}
</style>
